import { useEffect } from "react"
import TrackingTrunkForm from "./TrackingTrunkForm"


const TrackingTrunk = ({ open }) => {
    useEffect(() => {
        document.title = 'Tracking Trunk'
    }, [])
    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            < TrackingTrunkForm />
        </main>
    )
}
export default TrackingTrunk;
